const o = {
  fleet: {
    label: "车队长",
    keyName: "fleet",
    placeholder: "请选择车队长",
    type: "select",
  },
  date: {
    label: "日期",
    keyName: "date",
    placeholder: "请选择日期",
    type: "date",
  },
  month: {
    label: "月份",
    keyName: "month",
    placeholder: "请选择月份",
    type: "month",
  },
  license: {
    label: "车牌号",
    keyName: "license",
    placeholder: "请填写车牌号",
    type: "text",
  },
}

export default o